import React, { useEffect, useRef, useState } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../../assets/DataView/DataViewDemo.css";
import "../../../assets/DataView/index.css";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "jspdf-autotable";
import jsPDF from "jspdf";
import logoBig from "../../../assets/logo1.png";
import { FilterMatchMode } from 'primereact/api';
import { getProcessFee, getProduct } from "../../../services/userMasterUser";
import { errorMessage } from "../../../utils/alertMessage";
import { formatDate, formatDateWithTime } from "../../../constants/FormateDate";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { DataScroller } from "primereact/datascroller";
import { Button } from "primereact/button";

export default function ProcessFeeList() {

  const navigate = useNavigate();

  const { state } = useLocation();

  const [products, setProducts] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState(null);

  const ds = useRef(null);

  const [startDateValue, setStartDateValue] = useState(null);
    const [endDateValue, setEndDateValue] = useState(null);

  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(20);
  const [loadingMore, setLoadingMore] = useState(false);

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    description: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    category: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  });

  const [globalFilterValue, setGlobalFilterValue] = useState('');

  const searchByStatusData = [

    { label: "Name", value: "name" },
    { label: "Category", value: "category" },
    { label: "Description", value: "description" },
  ];

  const [searchByStatus, setSearchByStatus] = useState('name');

  const typeData = {
    searchByDTO: {
      searchBy: "",
      searchText: "",
      limit: 20,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      startDate: "",
      endDate: ""
    },
    statusIn: [],
    userIdIn: [],
    bankAccountIdIn: [],
    leadIdIn: [state?.lead?.id]
  };

  const fetchData = (data, append = false) => {
    setLoadingMore(true);

    getProcessFee(data)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs

          if (append) {
            setProducts((prev) => [...(prev || []), ...newData]);
          } else {
            setProducts(newData);
          }

          setTotalRecords(response.data.totalRecords || newData.length);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
      .finally(() => {
        setLoadingMore(false);
      });
  };

  useEffect(() => {
    fetchData({
      ...typeData,
      searchByDTO: {
        searchBy: "",
        searchText: "",
        limit: rows,
        offset: 0,
        sortBy: "",
        sortOrder: "desc",
        startDate: "",
        endDate: ""
      }
    });
  }, []);

  const loadMore = () => {
    const newOffset = first + rows;

    fetchData(
      {
        ...typeData,
        searchByDTO: {
          searchBy: "",
          searchText: "",
          limit: rows,
          offset: newOffset,
          sortBy: "",
          sortOrder: "desc",
          startDate: "",
          endDate: ""
        },
      },
      true // append mode
    );

    setFirst(newOffset);
  };

  const onFilter = (event) => {
    setFilters(event.filters);

    let searchBy = "";
    let searchText = "";

    // Detect which column filter is applied
    Object.keys(event.filters).forEach((key) => {
      if (key !== "global" && event.filters[key]?.value) {
        searchBy = key;
        searchText = event.filters[key].value;
      }
    });

    fetchData({
      searchByDTO: {
        searchBy: searchBy,
        searchText: searchText,
        limit: 20,
        offset: 0,
        sortBy: "",
        sortOrder: "desc",
        startDate: "",
        endDate: ""
      },
      statusIn: [],
      userIdIn: [],
      bankAccountIdIn: [],
      leadIdIn: [state?.lead?.id]
    });
  };

   useEffect(() => {
      let startDate = "";
      let endDate = "";
  
      if (startDateValue) {
        startDate = new Date(startDateValue);
        endDate = endDateValue ? new Date(endDateValue) : new Date();
      }
  
      const hasValidFilter =
        startDateValue ||
        endDateValue;
  
      if (!hasValidFilter) return;
  
      const payload = {
        ...typeData,
        searchByDTO: {
          searchBy: "",
          searchText: "",
          limit: rows,
          offset: 0,
          sortBy: "",
          sortOrder: "desc",
          startDate,
          endDate
        },
      };
  
      fetchData(payload);
  
    }, [ 
      startDateValue,
      endDateValue, 
    ]);

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;

    setGlobalFilterValue(value);
    setFirst(0);
    setProducts([]);

    fetchData({
      searchByDTO: {
        searchBy: searchByStatus,
        searchText: value,
        limit: 20,
        offset: 0,
        sortBy: "",
        sortOrder: "desc",
        startDate: "",
        endDate: ""
      },
      statusIn: [],
      userIdIn: [],
      bankAccountIdIn: [],
      leadIdIn: [state?.lead?.id]
    });
  };

  const downloadPDF = (data) => {
    if (!data || data.length === 0) return;

    const doc = new jsPDF("landscape");
    const logoImg = new Image();
    logoImg.src = logoBig;

    doc.addImage(logoImg, "PNG", 10, 5, 40, 15);
    doc.setFontSize(16);
    doc.text("CA User Data", 200, 15);

    doc.autoTable({
      head: [["ID", "Date", "Name", "Mobile", "City", "State", "Status"]],
      body: data.map((item) => [
        item.id,
        formatDate(item.createdDate),
        item.name,
        item.mobile,
        item.city,
        item.state,
        item.status ? "ACTIVE" : "INACTIVE"
      ]),
      startY: 25,
      theme: "grid",
      styles: { fontSize: 9 }
    });

    doc.save("CA-User-List.pdf");
  };

  const itemTemplate = (data) => {
    return (
      <div>
      </div>
    )
  }

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/")}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div>Fee List
                </h5>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 5,
                    marginBottom: 5,
                  }}
                >
                  <div className="row">
                    <div className="col-md mb-2">
                      <InputText
                        type="text"
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange}
                        placeholder="Keyword Search"
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div className="col-md mb-2">
                      <Dropdown
                        style={{ width: "100%" }}
                        options={searchByStatusData}
                        value={searchByStatus}
                        onChange={(e) => {
                          setSearchByStatus(e.value);
                        }}
                      />
                    </div>
                    {/*<div className="col-md mb-2">
                      <Calendar
                        value={startDateValue}
                        onChange={(e) => {
                          const start = e.value;
                          setStartDateValue(start);

                          if (!endDateValue) {
                            setEndDateValue(new Date()); // default today
                          }
                        }}
                        dateFormat="dd/mm/yy"
                        placeholder="Start Date"
                        maxDate={endDateValue ? endDateValue : new Date()}
                        showIcon
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div className="col-md mb-2">
                      <Calendar
                        value={endDateValue}
                        onChange={(e) => setEndDateValue(e.value)}
                        dateFormat="dd/mm/yy"
                        placeholder="End Date"
                        minDate={startDateValue}
                        showIcon
                        style={{ width: "100%" }} />
                    </div>*/}

                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      gap: 10,
                      // justifyContent: "center",
                      // alignItems: "center",
                    }}
                  >
                    <div className="col-md-2" style={{ alignSelf: "center" }}>
                      <Link
                        to="/process-fee/create"
                        state={{ leadData: state }}
                        className="move-btn move-btn-blue center-text"
                      >
                        Create
                      </Link>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: 20,
                          // marginTop: 10,
                        }}
                      >
                        {/*<i
                          onClick={() =>
                            downloadPDF(
                              filteredProducts || products,
                              "download"
                            )
                          }
                          className="pi pi-download"
                          style={{
                            fontSize: "20px",
                            color: "#1e439b",
                            cursor: "pointer",
                          }}
                        ></i>*/}
                        {/*<i
                          onClick={() =>
                            downloadPDF(filteredProducts || products, "print")
                          }
                          className="pi pi-print"
                          style={{
                            fontSize: "20px",
                            color: "#ff0101",
                            cursor: "pointer",
                          }}
                        ></i>*/}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="dataview-demo">
                  <div className="card">
                    <DataTable
                      value={products}
                      // lazy
                      dataKey="id"
                      paginator
                      paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                      rows={rows}
                      rowsPerPageOptions={[rows, rows + 50, rows + 100]}
                      loading={loadingMore}
                      className="p-datatable-customers client-table-design"
                      resizableColumns
                      columnResizeMode="fit"
                      filters={filters}
                      onFilter={onFilter}
                      // filterDisplay="row"
                      globalFilterFields={['id', 'createdDate', 'name', "mobile", "city", "state"]}
                      stripedRows
                    >
                      <Column
                        header="#"
                        resizeable={false}
                        className="product-category table-design"
                        body={(data, options) => options.rowIndex + 1}
                      ></Column>
                      <Column
                        field="fileNo"
                        header="File No"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.fileNo}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="total"
                        header="Total"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.total}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="paid"
                        header="Paid"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.paid}
                          </span>
                        )}
                      ></Column>
                      
                      <Column
                        field="balance"
                        header="Balance"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.balance}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="paidOn"
                        header="Paid On"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {formatDateWithTime(rowData.paidOn)}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="otherInfo"
                        header="Other Info"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.otherInfo}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="leadName"
                        header="Lead Name"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.lead?.name}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="bankAccount"
                        header="Bank Account"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.bankAccount?.name}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="receivedBy"
                        header="Received By"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.receivedBy?.userName}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="status"
                        header="Status"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {(rowData.status)}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="Edit"
                        header="Edit"
                        className="product-category table-design"
                        body={(rowData) => (
                          <Link
                            to={"/process-fee/edit"}
                            state={{ state: rowData, leadData: state }}
                            className="move-btn move-btn-yellow center-text"
                          >
                            Edit <i className="bi bi-pencil-square"></i>
                          </Link>
                        )}
                      ></Column>
                    </DataTable>
                  </div>
                  <DataScroller
                                      ref={ds} 
                                      value={products} 
                                      itemTemplate={itemTemplate} 
                                      rows={5} 
                                      loader 
                                      // footer={footer} 
                                      // header="Click Load Button at Footer to Load More" 
                                    />
                                    <div
                                      className="flex justify-content-center fixed "
                                      style={{ bottom: 30, left: 20 }}
                                    >
                                      <Button
                                        type="text"
                                        icon="pi pi-plus"
                                        // label="More"
                                        onClick={loadMore} // Update this to trigger `getData`
                                      />
                                    </div>
                                    {/*products && products.length < totalRecords && (
                                      <div style={{ textAlign: "center", margin: "20px" }}>
                                        <button
                                          onClick={loadMore}
                                          disabled={loadingMore}
                                          style={{
                                            padding: "10px 20px",
                                            backgroundColor: "#1e439b",
                                            color: "#fff",
                                            border: "none",
                                            cursor: "pointer",
                                            borderRadius: "5px"
                                          }}
                                        >
                                          {loadingMore ? "Loading..." : "Load More"}
                                        </button>
                                      </div>
                                    )*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
